import { ArrowRight, User, ScrollText, Users } from "lucide-react";
import { ArcButton } from "@/components/ArcButton";
import EncyclopediaSidebar from "@/components/EncyclopediaSidebar";
import { Editable, EditableImage, ImageBlockZone } from "@/components/Editable";

const FEATURED = [
  { icon: User, title: "Ghoulax", desc: "The central figure documented throughout the Glorious Ghoulax Archives.", btn: "READ ARTICLE", to: "/article/ghoulax?enc=ghoulax" },
  { icon: ScrollText, title: "The History of Ghoulax", desc: "A chronological collection of notable events, projects, community moments, and lore.", btn: "VIEW TIMELINE", to: "/article/history-of-ghoulax?enc=ghoulax" },
  { icon: Users, title: "The Ghoulax Community", desc: "Information about the community, staff, fans, roles, events, and notable moments.", btn: "EXPLORE COMMUNITY", to: "/article/ghoulax-community?enc=ghoulax" },
];

export default function GhoulaxHome() {
  return (
    <div className="mx-auto max-w-6xl px-4 py-8 sm:px-6 sm:py-12">
      <header className="border-b pb-6" style={{ borderColor: "var(--ghoulax)" }}>
        <p className="text-xs font-bold uppercase tracking-widest" style={{ color: "var(--ghoulax)" }}>The Archives</p>
        <Editable id="ghoulax.header" as="h1" fallback="THE GLORIOUS GHOULAX ARCHIVES" className="mt-2 font-serif-arc text-3xl font-black tracking-tight sm:text-4xl lg:text-5xl" style={{ color: "var(--ghoulax)" }} />
        <Editable id="ghoulax.subtitle" as="p" fallback={'"An entirely unbiased historical institution."'} className="mt-3 text-base italic" style={{ color: "var(--arc-text-2)" }} />
        <Editable id="ghoulax.disclaimer" as="p" mode="multiline" fallback="This is an unofficial fan-made community encyclopedia. Some sections contain satire, jokes, exaggeration, and community lore." className="mt-4 max-w-3xl text-sm leading-relaxed" style={{ color: "var(--arc-text-2)" }} />
      </header>

      <div className="mt-8 flex flex-col gap-8 lg:flex-row">
        <EncyclopediaSidebar enc="ghoulax" />

        <div className="min-w-0 flex-1">
          {/* Featured article - large */}
          <section
            data-testid="ghoulax-featured-article"
            className="mb-6 overflow-hidden rounded-md border-2 p-6 shadow-sm sm:p-8"
            style={{ backgroundColor: "var(--arc-card)", borderColor: "var(--ghoulax)" }}
          >
            <p className="text-xs font-bold uppercase tracking-widest" style={{ color: "var(--ghoulax)" }}>Featured Article</p>
            <h2 className="mt-2 font-serif-arc text-2xl font-black sm:text-3xl">Ghoulax</h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed" style={{ color: "var(--arc-text-2)" }}>
              The central figure documented throughout the Glorious Ghoulax Archives.
            </p>
            <div className="mt-6">
              <ArcButton to="/article/ghoulax?enc=ghoulax" variant="ghoulax" className="w-full sm:w-auto">READ ARTICLE <ArrowRight size={16} /></ArcButton>
            </div>
          </section>

          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            {FEATURED.slice(1).map((f) => (
              <section key={f.title} className="flex flex-col rounded-md border p-6 shadow-sm" style={{ backgroundColor: "var(--arc-card)" }}>
                <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-md" style={{ backgroundColor: "var(--ghoulax-soft)" }}>
                  <f.icon size={20} style={{ color: "var(--ghoulax)" }} />
                </div>
                <h3 className="font-serif-arc text-xl font-bold">{f.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed" style={{ color: "var(--arc-text-2)" }}>{f.desc}</p>
                <div className="mt-5">
                  <ArcButton to={f.to} variant="outline" className="w-full sm:w-auto">{f.btn} <ArrowRight size={16} /></ArcButton>
                </div>
              </section>
            ))}
          </div>

          <div className="mt-6">
            <ArcButton to="/ghoulax/all" variant="outline" data-testid="ghoulax-view-more" className="w-full justify-center py-3">
              View More Articles <ArrowRight size={16} />
            </ArcButton>
          </div>

          <p className="mt-10 text-center text-xs italic" style={{ color: "var(--arc-text-2)" }}>
            Historical accuracy: suspiciously high.
          </p>

          <ImageBlockZone id="ghoulax.blocks" className="mt-8" />
        </div>
      </div>
    </div>
  );
}
